module.exports = __webpack_public_path__ + "media/public/fonts/QanelasThin/QanelasThin-c8cd21c41f8b4f9660078a6856274d66.ttf";